<template>
  <div>
    <b-row class="mb-1">
      <b-col>
        <b-button
          v-if="$can('Create', 'CommissionFee')"
          variant="primary"
          :to="{ name: 'CommissionFee-create' }"
        >
          <span class="text-nowrap">Add New</span>
        </b-button>
      </b-col>
    </b-row>

    <b-card title="Commission Fee">
      <!-- search input -->

      <b-row>
        <b-col>
          <div class="custom-search d-flex justify-content-start">
            <b-form-group>
              <div>
                <b-form-input
                  v-model="searchTerm"
                  placeholder="Search"
                  type="text"
                  class="d-inline-block mr-1"
                />
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->

          <span v-if="props.column.field === 'fixedType'">
            <span>{{
              props.row.commissionType === 2
                ? (props.row.fixedType = null)
                : props.row.fixedType === 1
                ? "Single"
                : "Range"
            }}</span>
          </span>
          <span v-else-if="props.column.field === 'amount'">
            <span>{{
              props.row.commissionType === 2
                ? props.row.amount
                : props.row.fixedType === 1
                ? props.row.amount
                : (props.row.amount = null)
            }}</span>
          </span>

          <span v-else-if="props.column.field === 'status'">
            <span>
              <b-badge
                v-if="props.row.status === 'Active'"
                pill
                variant="success"
              >
                Active
              </b-badge>
              <b-badge
                v-else-if="props.row.status === 'Closed'"
                pill
                variant="danger"
              >
                Closed
              </b-badge>
            </span>
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-if="$can('Update', 'CommissionFee')"
                  variant="info"
                  v-b-modal.modal-paymentoption
                  @click="fetchDetailData(props.row.id)"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Detail</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    $can('Update', 'CommissionFee') &&
                      props.row.status === 'Active'
                  "
                  variant="warning"
                  v-b-modal.modal-edit-Commission
                  :to="{
                    name: 'CommissionFee-update',
                    params: { id: props.row.id },
                  }"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Edit</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <b-modal
        id="modal-paymentoption"
        ref="modal"
        hide-footer
        title="Commission Details"
        size="lg"
      >
        <b-card-body>
          <b-row>
            <b-col md="6">
              <b-form-group class="d-flex p-1">
                Merchant: <strong>{{ commissionDetail.merchant }}</strong>
              </b-form-group>
              <b-form-group class="d-flex p-1">
                Commission Type:
                <strong
                  >{{ commissionDetail.commissionTypeDescription }}
                </strong>
              </b-form-group>
              <b-form-group class="d-flex p-1">
                Effective Date From:
                <strong> {{ commissionDetail.effectiveDateFrom }}</strong>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group class="d-flex p-1">
                Status:
                <strong> {{ commissionDetail.status }}</strong>
              </b-form-group>
              <b-form-group
                class="d-flex p-1"
                v-if="commissionDetail.commissionType === 1"
              >
                Fixed Type:
                <strong>
                  {{
                    commissionDetail.fixedType === 1 ? "Single" : "Range"
                  }}</strong
                >
              </b-form-group>

              <b-form-group class="d-flex p-1">
                Effective Date To:
                <strong> {{ commissionDetail.effectiveDateTo }} </strong>
              </b-form-group>
            </b-col>
            <b-col v-if="commissionDetail.fixedType === 2">
              <strong class="d-flex p-1">Commission Range: </strong>
              <hr />
              <b-row
                v-for="(item, index) in commissionDetail.commissionRange"
                :key="index"
                cols-md="6"
                class="d-flex p-2"
              >
                <b-col md="3">
                  Min Range : <strong>{{ item.minRange }} </strong>
                </b-col>
                <b-col md="3">
                  Max Range : <strong>{{ item.maxRange }} </strong>
                </b-col>
                <b-col md="3">
                  Amount : <strong>{{ item.amount }} </strong>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-overlay :show="isLoadingmodal" no-wrap rounded="sm" />
        </b-card-body>
      </b-modal>

      <!-- <b-modal
        id="modal-edit-Commission"
        title="Are You Sure to Update the Commission"
        ok-title="Save"
        cancel-variant="outline-secondary"
        size="lg"
      >
        <validation-observer ref="simpleRules">
          <form ref="form" @submit.stop.prevent=" ">
            <strong>Choose end date: </strong>
            <hr />
            <b-row>
              <b-form-input v-model="editCommission.id" hidden />
              <b-form-input v-model="editCommission.merchantId" hidden />
              <b-col cols="6">
                <b-form-group label="Code" label-for="code">
                  <validation-provider
                    #default="{ errors }"
                    name="Merchant"
                    rules="required"
                  >
                    <b-form-input
                      id="code-input"
                      v-model="editCommission.merchant"
                      :state="errors.length > 0 ? false : null"
                      disabled
                      >kjgjkh</b-form-input
                    >
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Code" label-for="code">
                  <validation-provider
                    #default="{ errors }"
                    name="code"
                    rules="required"
                  >
                    <b-form-input
                      id="code-input"
                      v-model="editCommission.id"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <div>
                  <b-form-datepicker
                    id="extended-date"
                    v-model="updatedDate"
                    :min="min"
                    class="mb-2"
                  />
                </div>
              </b-col>
            </b-row>
          </form>
        </validation-observer>
        <b-overlay :show="isLoadingmodal" no-wrap rounded="sm" />
      </b-modal> -->
      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BForm,
  BRow,
  BCol,
  BCard,
  // BAvatar,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BFormDatepicker,
  BCardBody,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import axios from "@axios";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const now = new Date();
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
const minDate = new Date(today);
export default {
  name: "Roles",
  components: {
    BForm,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    // BAvatar,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    BCardBody,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      isLoading: false,
      isLoadingmodal: false,
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      activeRow: null,
      commissionDetail: {},
      columns: [
        {
          label: "Merchant",
          field: "merchant",
        },
        {
          label: "Commission Type",
          field: "commissionTypeDescription",
        },
        {
          label: "Fixed Type",
          field: "fixedType",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Effective Date From",
          field: "effectiveDateFrom",
        },
        {
          label: "Effective Date To",
          field: "effectiveDateTo",
        },

        {
          label: "Status",
          field: "status",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
      selectedId: 0,
      min: minDate,
      editCommission: {
        id: "",
        merchantId: null,
        commissionType: null,
        fixedType: null,
        amount: null,
        effectiveDateFrom: null,
        effectiveDateTo: null,
        commissionRangeRequest: [{ minRange: 0, maxRange: 0, amount: 0 }],
      },
      updatedDate: `${now.getUTCFullYear()}-${now.getUTCMonth() +
        1}-${now.getUTCDate()}`,
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    accessTypeVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-info",
        2: "light-primary",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch("config/getActionPrivilege", "CommissionFee-GetAll");
      this.isLoading = true;
      axios
        .get("/Commission/api/V1.0/CommissionFee/GetAll")
        .then((res) => {
          this.isLoading = false;
          this.rows = res.commissionFees;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    fetchDetailData(id) {
      this.isLoadingmodal = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-Detail");
      axios
        .get(`/Commission/api/V1.0/CommissionFee/GetById?id=${id}`)
        .then((res) => {
          this.commissionDetail = res.commissionFee;
          this.isLoadingmodal = false;
          // console.log(res)
        })
        .catch((res) => {
          console.log(res);
          this.isLoadingmodal = false;
        });
    },
    editcommission(id) {
      this.isLoadingmodal = true;
      this.selectedId = id;

      this.$store.dispatch("config/getActionPrivilege", "CommissionFee-Update");
      axios
        .get(`/Commission/api/V1.0/CommissionFee/GetById?id=${id}`)
        .then((res) => {
          this.editCommission = res.commissionFee;

          this.isLoadingmodal = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
